url = "https://medium.com/feed/@gt"
container = ".post-wrapper"
parseRSS = (url, body) ->
$.ajax
  url: document.location.protocol + '//ajax.googleapis.com/ajax/services/feed/load?v=1.0&num=10&callback=?&q=' + encodeURIComponent(url)
  dataType: 'json'
  success: (data) ->
    #console.log(data.responseData.feed);
    $.each data.responseData.feed.entries.slice(0, 3), (key, value) ->
      thehtml = '<div class="post"><div class="post-supporting-headline">Micro-contracts and the Iron Triangle</div><h3 class="post-title"><a href="' + value.link + '" target="_blank">' + value.title + '</a></h3><div class="post-meta">December 28 2014, 6 min read</div></div>'
      $(container).append thehtml

images = [
  'angrybirds'
  'big-bird'
  'biker-attack'
  'birdie-sanders'
  'larry-bird'
  'little-mermaid'
  'mighty-ducks'
  'pretty-bird'
]

$ =>
  $('html').css 'background-image', "url(/img/peaks/#{_.sample(images)}.gif)"
  $(window).on 'mousewheel', _.throttle @reveal, 10

